module.exports = __webpack_public_path__ + "media/images/features/apps_for_any_device_img-15f4abd0289df4c86ab13ac800904bfc.png";